import getCookieConsentPreferences, {
  defaultCookieConsentPreferences,
  gpcSignal,
} from "../../utils/cookie-consent"
import setUserProperties from "./analytics-identify"

function getConsentsData() {
  const cookieConsentPreferences = getCookieConsentPreferences()
  return {
    "Necessary cookies":
      cookieConsentPreferences?.personalization_storage ||
      defaultCookieConsentPreferences.personalization_storage,
    "Preferences cookies":
      cookieConsentPreferences?.functional_storage ||
      defaultCookieConsentPreferences.functional_storage,
    "Statistics cookies":
      cookieConsentPreferences?.analytics_storage ||
      defaultCookieConsentPreferences.analytics_storage,
    "Marketing cookies":
      cookieConsentPreferences?.ad_storage ||
      defaultCookieConsentPreferences.ad_storage,
    "Has GPC enabled": gpcSignal,
  }
}

function setConsentsDataOnUserProperty() {
  setUserProperties(getConsentsData())
}

export { setConsentsDataOnUserProperty }
export default getConsentsData
